import BuildOutlinedIcon from "@mui/icons-material/BuildOutlined";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import ForumOutlinedIcon from "@mui/icons-material/ForumOutlined";
import HubOutlinedIcon from "@mui/icons-material/HubOutlined";
import MenuBookOutlinedIcon from "@mui/icons-material/MenuBookOutlined";
import TuneIcon from "@mui/icons-material/Tune";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";

export const NAV_TABS = [
  { id: "general", label: "General", icon: TuneIcon },
  { id: "access", label: "Access", icon: VisibilityOutlinedIcon },
  { id: "chatUx", label: "Chat UX", icon: ForumOutlinedIcon },
  { id: "tools", label: "Tools", icon: BuildOutlinedIcon },
  { id: "mcp", label: "MCP", icon: HubOutlinedIcon },
  { id: "knowledge", label: "Knowledge", icon: MenuBookOutlinedIcon },
  { id: "email", label: "Email", icon: EmailOutlinedIcon },
  { id: "danger", label: "Delete", icon: DeleteOutlineIcon, danger: true },
];
